<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('puzzle.templateEdit.subtitle') }}
        </span>
        <h3 class="page-title">{{ $t('puzzle.templateEdit.title') }}</h3>
      </d-col>
    </d-row>

    <puzzle-template-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import PuzzleTemplatePage from '../components/PuzzleTemplatePage.vue';

export default {
  name: 'puzzle-template-edit',
  components: {
    PuzzleTemplatePage,
  },
  methods: {
    ...mapActions(['getPuzzle']),
  },
  mounted() {
    const id = this.$route.params.puzzleId;
    if (id) {
      this.getPuzzle({ id, search: null });
    }
  },
};
</script>
